import React, { useRef } from 'react';
import WebView from 'react-native-webview';

import useManageBatchTimeLine from '@components/wallboard/hooks/useManageBatchTimeLine';

const BatchTimeLine = ({
  C,
  height = 7,
  borderRadius = 3,
  batch,
  getMachineEventTimelineByBatchId,
  roundOnlyBottom,
  roundOnlyTop,
  scale,
  localTime,
  productionBatchId,
  tileWidth,
  status,
  withGaps = true,
}) => {
  const webView = useRef(null);

  const { htmlSource, radiusStyle, containerBg } = useManageBatchTimeLine({
    batch,
    getMachineEventTimelineByBatchId,
    productionBatchId,
    status,
    C,
    height,
    borderRadius,
    roundOnlyTop: !!roundOnlyTop,
    roundOnlyBottom: !!roundOnlyBottom,
    scale,
    localTime,
    withGaps,
  });

  return (
    <WebView
      ref={webView}
      key={`${scale(1)}`}
      originWhitelist={['*']}
      source={{ html: htmlSource }}
      scrollEnabled={false}
      style={[{ height, backgroundColor: containerBg }, radiusStyle]}
    />
  );
};

export default React.memo(
  BatchTimeLine,
  (prev, next) =>
    prev?.productionBatchId === next?.productionBatchId &&
    prev?.batch?.startedOn === next?.batch?.startedOn &&
    prev?.batch?.demoMachineEvents === next?.batch?.demoMachineEvents &&
    prev?.status === next?.status &&
    prev.height === next.height
);
